module.exports = __webpack_public_path__ + "img/materials.c6ba36a7.png";